






































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { PaginationModel, VHeaders } from '@/models/pagedlistmodel';
import { AttachmentType } from '@/models/fixedops/attachment';
import { Base } from '@/components/common/base';
import { IDialogOption } from '@/models/dialog';
import { getAttachmentHeaders } from '@/views/admin/attachmenttype/attachmentType';
import { attachmentTypeService } from '@/shared';

@Component({
  props: ['methodName', 'progress'],
  computed: {
    methodtoCall: {
      get() {
        return this.$props.methodName;
      },
    },
  },
  components: {
    Grid: () => import('@/components/common/app.grid.vue'),
    AppDialog: () => import('@/components/common/app.dialog.vue'),
  },
})
export default class AttachmentTypeListPage extends Base {
  public headers: VHeaders[] = getAttachmentHeaders(this);
  public pagedAttchamentTypes: AttachmentType[] = [];
  public pagination = new PaginationModel('name');
  public loading: boolean = false;
  public tenantId: number = 0;
  public enterpriseId: number = 0;
  public actions: any[] = [];

  public deleteDialog: IDialogOption = {
    width: 400,
    title: this.$parent.$t('attachmentTypes.deleteDialogTitle') as string,
    model: false,
    action: { color: 'success', icon: 'fas fa-check', text: 'Agree' },
    loading: false,
    onAction: (): void => {
      this.deleteAttachmentType();
    },
  };
  public typeToDelete: AttachmentType = {
    name: '',
    description: '',
  };

  public searched: boolean = false;
  public deleted: boolean = false;
  public setActions() {
    this.actions = [
      {
        type: 'link',
        icon: 'fas fa-edit',
        title: this.$t(
          'attachmentTypes.attachmentTypeGridHeaders.gridAction.edit'
        ) as string,
        action: (model: AttachmentType, storeid: string) => ({
          name: 'admin.attachmenttypes.edit',
          params: {
            tenantId: this.tenantId,
            enterpriseId: this.enterpriseId,
            id: model.id,
          },
        }),
      },
      {
        type: 'button',
        icon: 'fas fa-trash-alt',
        title: this.$t(
          'attachmentTypes.attachmentTypeGridHeaders.gridAction.delete'
        ) as string,
        color: 'error',
        action: (model: AttachmentType, storeid: string) => {
          this.confirmDelete(model);
        },
      },
    ];
  }

  public beforeDestroy() {
    const buttons = [];
    this.$emit('updateToolBar', buttons);
  }
  public callMethod(methodName): void {
    if (methodName === 'addAttachmentType') {
      this.$router.push({ name: 'admin.attachmenttypes.add' });
    }
  }
  public updateToolBar(): void {
    const buttons: any = [];
    buttons.push({
      id: '0',
      type: 'button',
      title: this.$t('attachmentTypes.btnAddAttachmentType'),
      disabled: false,
      visible: true,
      class: 'btn',
      label: this.$t('attachmentTypes.btnAddAttachmentType'),
      click: 'addAttachmentType',
      icon: 'fas fa-plus-circle',
    });
    this.$emit('updateToolBar', buttons);
  }
  public mounted() {
    // activating tab
    this.$root.$emit('sidebar.layout.vue', 'attachmentType');

    // Toolbar
    this.updateToolBar();
    this.$watch('methodtoCall', (newVal, oldVal) => {
      if (newVal) {
        this.callMethod(newVal);
      }
    });

    this.setActions();
    this.getAttachmentTypes();
  }
  public async getAttachmentTypes(): Promise<void> {
    try {
      this.loading = true;
      const attchmentTypes = await attachmentTypeService.getAttachmentTypesAsync(
        this.pagination
      );
      this.pagedAttchamentTypes = attchmentTypes.results;
      this.pagination.totalItems = attchmentTypes.total;
    } finally {
      this.loading = false;
    }
  }

  public updatePaging(paging: any) {
    this.pagination = paging;
  }
  public confirmDelete(item: AttachmentType): void {
    this.deleteDialog.model = true;
    this.typeToDelete = item;
  }
  public async deleteAttachmentType(): Promise<void> {
    try {
      this.deleteDialog.loading = true;
      await attachmentTypeService.deleteAttachmentTypes(this.typeToDelete.id);
      this.deleted = true;
      this.showAlert(
        true,
        this.$t('attachmentTypes.alertDeleteAttachmentType')
      );
      this.getAttachmentTypes();
    } finally {
      this.deleteDialog.loading = false;
      this.deleteDialog.model = false;
    }
  }
}
